var Family = /** @class */ (function () {
    function Family(props) {
        Object.assign(this, props);
    }
    return Family;
}());
export { Family };



//////////////////
// WEBPACK FOOTER
// ./src/modules/Families/Model.ts
// module id = 689
// module chunks = 0